export default [
  {
    title: '月份',
    key: 'checkTime',
    width: 62
  },
  {
    title: '奖金起算金额(元)',
    key: 'threshold',
    width: 120
  },
  {
    title: '类型',
    key: 'type'
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 120
  },
  {
    title: '更新人',
    key: 'updateOpName'
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 114
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 114
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
